import { getClass } from '../../../_lib/helper';
/**
 * Responsive properties
 */
export var responsiveProperties = [
    { property: 'display', prefix: 'flex-' },
    { property: 'direction', prefix: 'flex-' },
    { property: 'wrap', prefix: 'flex-' },
    { property: 'justifyContent', prefix: 'justify-content-' },
    { property: 'alignItems', prefix: 'align-items-' },
    { property: 'alignContent', prefix: 'align-content-' },
];
/**
 *
 * @param breakpoint
 * @param options
 */
export function mapResponsive(block, breakpoint, options) {
    if (options === null || options === undefined) {
        return '';
    }
    return responsiveProperties
        .map(function (item) {
        if (options[item.property] !== undefined) {
            return "".concat(item.prefix).concat(breakpoint, "-").concat(options[item.property]);
        }
        return undefined;
    })
        .join(' ');
}
/**
 *
 * @param block
 * @param props
 */
export function mapPropsToClass(block, props) {
    var _a;
    return getClass(block, (_a = {},
        _a["".concat(props.className)] = props.className,
        _a["no-gutters"] = props.isNoGutters,
        _a["flex-inline"] = props.isInline,
        _a["flex-".concat(props.direction)] = props.direction,
        _a["flex-".concat(props.wrap)] = props.wrap,
        _a["justify-content-".concat(props.justifyContent)] = props.justifyContent,
        _a["align-items-".concat(props.alignItems)] = props.alignItems,
        _a["align-content-".concat(props.alignContent)] = props.alignContent,
        _a["".concat(mapResponsive(block, 'xs', props.xs))] = props.xs,
        _a["".concat(mapResponsive(block, 'sm', props.sm))] = props.sm,
        _a["".concat(mapResponsive(block, 'md', props.md))] = props.md,
        _a["".concat(mapResponsive(block, 'lg', props.lg))] = props.lg,
        _a["".concat(mapResponsive(block, 'xl', props.xl))] = props.xl,
        _a["".concat(mapResponsive(block, 'xxl', props.xxl))] = props.xxl,
        _a), []);
}
